module.exports = __webpack_public_path__ + "static/media/AlbanyAdvertiser-devicecomp-min@2x.c4c90ef3.webp";